import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

import IconInfoOrange from '../../assets/images/common/icon-info-orange.svg';
import ArrowRightOrange from '../../assets/images/common/arrow-right-orange.svg';
import ArrowBackBlue from '../../assets/images/common/arrow-back-blue.svg';

import { TS_SCREEN, TsType } from '../../types/common/CommonType';
import { CustomerInformationInputType, CI_INPUT_MODE } from '../../types/common/CustomerInformationType';
import { MasterInquireApiResponse } from '../../types/api/MasterInquireApiType';

import { CustomerInformationInput } from './CustomerInformationInput';
import { CustomerInformationLogic } from './CustomerInformationLogic';
import { PrivacyPolicyModal } from '../../pages/Modals/PrivacyPolicyModal';
import { ErrorModalModal } from '../../components/ErrorModal';

type CustomerInformationBodyProps = {
    cIInput: CustomerInformationInputType; // 個人情報入力管理
    setCIInput: (value: CustomerInformationInputType) => void; // 個人情報入力管理setState
    screenTransition: TsType; // 遷移元情報
    masterInquire: MasterInquireApiResponse; // お問い合わせ種別、お問い合わせ理由のマスタ
};

export const CustomerInformationBody: React.FC<CustomerInformationBodyProps> = ({
    cIInput,
    setCIInput,
    screenTransition,
    masterInquire,
}) => {
    const navigation = useNavigate();

    // エラー表示
    const [errorMessages, setErrorMessages] = useState<Array<string>>([]);
    // エラー モーダル開閉管理
    const [openErrorlModal, setOpenErrorModal] = useState<boolean>(false);
    // 個人情報保護 モーダル開閉管理
    const [openPrivacyPolicylModal, setOpenPrivacyPolicyModal] = useState<boolean>(false);
    // エラーモーダル表示
    const [errorModalMessages, setErrorModalMessages] = useState<Array<string>>([]);

    // 入力内容チェック
    const checkInput = () => {
        const result = CustomerInformationLogic.ciInputValidation(cIInput, setErrorMessages);
        if (result.length > 0) {
            setErrorModalMessages(result);
            setOpenErrorModal(true);
        } else {
            // 確認画面に遷移
            navigation('/confirmation');
        }
    };

    return (
        <>
            <section className='section page_title up_top_title'>
                <div className='container'>
                    <div className='columns is-desktop'>
                        <div className='column is-6-widescreen-only is-12-mobile page_title-thead'>
                            <h1>お客様情報のご入力</h1>
                            <p className='discription'>お客様に関する情報を入力してください。</p>
                        </div>
                        <div className='column is-6-widescreen-only is-12-mobile'>
                            <div className='alert_box'>
                                <span className='icon'>
                                    <img src={IconInfoOrange} alt='' />
                                </span>
                                <span className='text'>まだ送信は完了していません</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='section content-wrapper up_top form'>
                <div className='container'>
                    <div className='columns'>
                        <div className='column is-12'>
                            <p className='para-small'>
                                情報が不足している場合など、見積が出来ない場合などに詳細をお伺いしますので、可能な限りご入力ください。
                            </p>
                        </div>
                    </div>
                    <CustomerInformationInput
                        dataInput={CI_INPUT_MODE.WRITE}
                        cIInput={cIInput}
                        setCIInput={setCIInput}
                        errorMessages={errorMessages}
                        masterInquire={masterInquire}
                    />
                </div>
            </section>
            <section className='section bottom_cta'>
                <div className='container'>
                    <div className='columns'>
                        <div className='column'>
                            <div className='field is-horizontal p_poly'>
                                <div className='field'>
                                    <div className='control'>
                                        <label className='label required'></label>
                                        <label className='checkbox'>
                                            <input
                                                type='checkbox'
                                                checked={cIInput.pPolicyCheck}
                                                onChange={(e) =>
                                                    setCIInput({ ...cIInput, pPolicyCheck: e.target.checked })
                                                }
                                            />
                                        </label>
                                        <span className='p_poly--modal' onClick={() => setOpenPrivacyPolicyModal(true)}>
                                            <span className='js-modal-trigger' data-target='modal-p_poly'>
                                                当社の個人情報保護方針
                                            </span>
                                            に同意する
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className='bottom_cta--next'>
                                <a className='button is-dl_blue' onClick={checkInput}>
                                    送信内容を確認する
                                    <span className='icon is-small'>
                                        <img src={ArrowRightOrange} alt='' />
                                    </span>
                                </a>
                                {screenTransition === TS_SCREEN.EST ? (
                                    <Link to='/editDeviceList' className='button is-buck'>
                                        戻る
                                        <span className='icon is-small'>
                                            <img src={ArrowBackBlue} alt='' />
                                        </span>
                                    </Link>
                                ) : (
                                    <Link to='/contact' className='button is-buck'>
                                        戻る
                                        <span className='icon is-small'>
                                            <img src={ArrowBackBlue} alt='' />
                                        </span>
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <PrivacyPolicyModal openState={openPrivacyPolicylModal} setOpenState={setOpenPrivacyPolicyModal} />
            <ErrorModalModal
                errorMessages={errorModalMessages}
                openState={openErrorlModal}
                setOpenState={setOpenErrorModal}
            />
        </>
    );
};
